import apiClient from './config';
import { PlantillaSemanal } from '../../types/index';

// Función para obtener todas las plantillas semanales
export const fetchPlantillasSemanales = async (): Promise<PlantillaSemanal[]> => {
    const response = await apiClient.get('/plantillas-semanales');
    return response.data;
};

// Función para obtener una plantilla semanal por ID
export const fetchPlantillaSemanalById = async (id: string): Promise<PlantillaSemanal> => {
    const response = await apiClient.get(`/plantillas-semanales/${id}`);
    return response.data;
};

// Función para crear una plantilla semanal
export const createPlantillaSemanal = async (plantilla: PlantillaSemanal): Promise<PlantillaSemanal> => {
    const response = await apiClient.post('/plantillas-semanales', plantilla);
    return response.data;
};

// Función para actualizar una plantilla semanal
export const updatePlantillaSemanal = async (plantilla: PlantillaSemanal): Promise<PlantillaSemanal> => {
    const response = await apiClient.put(`/plantillas-semanales/${plantilla._id}`, plantilla);
    return response.data;
};

// Función para eliminar una plantilla semanal
export const deletePlantillaSemanal = async (id: string): Promise<void> => {
    await apiClient.delete(`/plantillas-semanales/${id}`);
};
